import { render } from "./AreaConhecimento.vue?vue&type=template&id=b7c4efb8&scoped=true"
import script from "./AreaConhecimento.vue?vue&type=script&lang=js"
export * from "./AreaConhecimento.vue?vue&type=script&lang=js"

import "./AreaConhecimento.vue?vue&type=style&index=0&id=b7c4efb8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7c4efb8"]])

export default __exports__